<div [ngClass]="graphDisabled ? 'graph-enable' : 'graph-disable'">
    <svg width="500" height="500" id="svg2">
    </svg>
</div>